export const path = "/openai";

export const apiUrls = {};
